module.exports = __webpack_public_path__ + "img/bosfor-price_en.f87b7068.svg";